<template>
  <div class="app-container">
    
    <!-- MOBILE SIDEBAR (Premium Redesign) -->
    <transition name="slide-fade">
    <div v-if="showMobileSidebar" class="mobile-sidebar-overlay" @click="closeMobileSidebar">
      <div class="mobile-sidebar" @click.stop>
          <!-- Mobile Sidebar Header with Gradient -->
        <div class="mobile-sidebar-header">
            <div class="sidebar-header-top">
              <div class="sidebar-logo">
                <img src="/Sparrow Logo 1.png" alt="Sparrow" class="sidebar-logo-img" />
        </div>
              <button class="sidebar-close-btn" @click="closeMobileSidebar">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
              </button>
            </div>
            
            <!-- User Profile Section in Sidebar -->
            <div class="sidebar-user-section" @click="goToProfile">
              <div class="sidebar-avatar-wrapper">
                <img v-if="isAuthenticated" :src="getAvatarUrl(avatarUrl)" class="sidebar-avatar" @error="handleAvatarError" />
                <div v-else class="sidebar-avatar-placeholder">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
              </svg>
                </div>
              </div>
              <div class="sidebar-user-info">
                <span class="sidebar-user-name">{{ isAuthenticated ? userName : $t('app.guestUser') }}</span>
                <span class="sidebar-user-status">{{ isAuthenticated ? $t('app.tapViewProfile') : $t('app.tapSignIn') }}</span>
              </div>
              <svg class="sidebar-chevron" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M9 18l6-6-6-6"/>
              </svg>
            </div>
          </div>
          
          <!-- Navigation Links -->
          <div class="mobile-nav-section">
            <span class="mobile-nav-label">{{ $t('app.browse') }}</span>
            <div class="mobile-nav-links">
              <div class="mobile-nav-item" role="button" tabindex="0" @click="navigateAndClose('/MainPage')" @keypress.enter="navigateAndClose('/MainPage')">
                <div class="nav-item-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                    <polyline points="9 22 9 12 15 12 15 22"/>
                  </svg>
                </div>
                <span class="nav-item-text">{{ $t('app.home') }}</span>
              </div>
              
              <div class="mobile-nav-item" role="button" tabindex="0" @click="navigateAndClose('/recommendHouse')" @keypress.enter="navigateAndClose('/recommendHouse')">
                <div class="nav-item-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
                </div>
                <span class="nav-item-text">{{ $t('app.discover') }}</span>
              </div>
              
              <div class="mobile-nav-item" role="button" tabindex="0" @click="navigateAndClose('/AddHouse')" @keypress.enter="navigateAndClose('/AddHouse')">
                <div class="nav-item-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
                </div>
                <span class="nav-item-text">{{ $t('app.addPlace') }}</span>
              </div>
            </div>
          </div>
          
          <!-- Account Section -->
          <div class="mobile-nav-section">
            <span class="mobile-nav-label">{{ $t('app.account') }}</span>
            <div class="mobile-nav-links">
              <div class="mobile-nav-item" role="button" tabindex="0" @click="navigateAndClose('/userProfile')" @keypress.enter="navigateAndClose('/userProfile')">
                <div class="nav-item-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                </div>
                <span class="nav-item-text">{{ $t('app.myProfile') }}</span>
              </div>

              <div class="mobile-nav-item" role="button" tabindex="0" v-if="isAuthenticated" @click="handleLogout" @keypress.enter="handleLogout">
                <div class="nav-item-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                    <polyline points="16 17 21 12 16 7"/>
                    <line x1="21" y1="12" x2="9" y2="12"/>
              </svg>
                </div>
                <span class="nav-item-text">{{ $t('app.signOut') }}</span>
              </div>
              
              <div class="mobile-nav-item" role="button" tabindex="0" v-else @click="goToLogin" @keypress.enter="goToLogin">
                <div class="nav-item-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                    <polyline points="10 17 15 12 10 7"/>
                    <line x1="15" y1="12" x2="3" y2="12"/>
              </svg>
          </div>
                <span class="nav-item-text">{{ $t('app.signIn') }}</span>
        </div>
      </div>
    </div>

          <div class="mobile-nav-section">
            <span class="mobile-nav-label">{{ $t('app.language') }}</span>
            <div class="language-switcher mobile-language-switcher">
              <button type="button" :class="{ active: currentLocale === 'en' }" @click="changeLocale('en')">EN</button>
              <button type="button" :class="{ active: currentLocale === 'zh-CN' }" @click="changeLocale('zh-CN')">中文</button>
            </div>
          </div>

          <!-- Sidebar Footer -->
          <div class="sidebar-footer">
            <p>{{ $t('app.footer') }}</p>
        </div>
        </div>
      </div>
    </transition>

    <!-- TRUSTPILOT STYLE NAVBAR -->
    <nav class="tp-navbar">
      <div class="tp-container">
        
        <!-- LEFT: LOGO & MOBILE TOGGLE -->
        <div class="tp-left">
          <button class="tp-mobile-toggle" @click="toggleMobileSidebar">
            <svg width="24" height="24" fill="none" stroke="#1c1c1c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M3 12h18M3 6h18M3 18h18"/></svg>
          </button>
          
          <div class="tp-logo-wrapper" @click="ToMainPage">
            <img src="/Sparrow Logo 1.png" alt="Sparrow" class="tp-logo-image" />
          </div>
        </div>

        <!-- CENTER: EXPANDABLE SEARCH BAR -->
        <div class="tp-center">
          <div 
            class="tp-search-morph"
            :class="{ 'expanded': isSearchExpanded }"
            @click="expandSearch"
          >
            <div class="tp-beam-border"></div>
            <div class="tp-search-inner">
              <i class="el-icon-search tp-search-icon"></i>
          <input
            v-model="navSearchText"
                class="tp-search-input"
            type="text"
                :placeholder="$t('app.searchPlaceholder')"
            @keydown.enter="navSearch"
            @blur="collapseSearch"
                ref="searchInput"
          />
              <button class="tp-go-btn" @click="navSearch" v-if="isSearchExpanded">
                <i class="el-icon-right"></i>
          </button>
        </div>
          </div>
        </div>

        <!-- RIGHT: LINKS & ACTIONS -->
        <div class="tp-right">
            
          <!-- Navigation Links -->
          <div class="tp-nav-links">
            <router-link to="/recommendHouse" class="tp-link">{{ $t('app.discover') }}</router-link>
            <router-link to="/AddHouse" class="tp-link">{{ $t('app.addPlace') }}</router-link>
          </div>

          <div class="language-switcher desktop-language-switcher">
            <button type="button" :class="{ active: currentLocale === 'en' }" @click="changeLocale('en')">EN</button>
            <button type="button" :class="{ active: currentLocale === 'zh-CN' }" @click="changeLocale('zh-CN')">中文</button>
          </div>

          <!-- MOBILE PROFILE BUTTON (visible on mobile only, positioned right) -->
          <div class="tp-mobile-profile" @click="goToProfile">
            <img v-if="isAuthenticated" :src="getAvatarUrl(avatarUrl)" class="tp-mobile-avatar" @error="handleAvatarError" />
            <div v-else class="tp-mobile-avatar-placeholder">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
        </div>

          <!-- Notification Bell -->
          <button class="tp-icon-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1c1c1c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </button>

          <!-- Auth Section -->
          <div class="tp-auth">
            <!-- If Logged In -->
            <div v-if="isAuthenticated" class="tp-user" @click="toUserInfo">
              <img :src="getAvatarUrl(avatarUrl)" class="tp-avatar" @error="handleAvatarError" />
              <span class="tp-login-text">{{ userName }}</span>
            </div>

            <!-- If Not Logged In -->
            <button v-else class="tp-login-btn" @click="ToLogin">
              {{ $t('app.login') }}
            </button>
          </div>

        </div>
      </div>
    </nav>

    <!-- Main Content -->
    <div class="main-content">
      <router-view/>
    </div>
  </div>
</template>

<script>
import { clearStoredAuth, syncStoredAuthFromToken } from '@/utils/auth';
import { setLocale } from '@/i18n';
// NOTE: Interceptors are configured in main.js — do NOT duplicate them here.
// The main.js request interceptor adds the 'token' header.
// The main.js response interceptor handles 401 by removing the stale token.
export default {
  name: "SearchFinder",
  mounted() {
    this.syncAuthState();
    window.addEventListener('auth-logout', this.handleAuthLogout);
    window.addEventListener('sparrow-auth-updated', this.syncAuthState);
  },
  beforeDestroy() {
    window.removeEventListener('auth-logout', this.handleAuthLogout);
    window.removeEventListener('sparrow-auth-updated', this.syncAuthState);
  },
  data() {
    return {
      input: '',
      userName:'',
      isAuthenticated: false,
      showUserName: '',
      avatarUrl: '',
      navSearchText: '',
      showMobileSidebar: false,
      isSearchExpanded: false,
      isAdminUser: false,
      currentLocale: this.$i18n ? this.$i18n.locale : 'en',
    }
  },
  methods: {
    changeLocale(locale) {
      this.currentLocale = setLocale(locale);
    },
syncAuthState() {
  const payload = syncStoredAuthFromToken();
  if (!payload) {
    this.isAuthenticated = false;
    this.userName = '';
    this.avatarUrl = '';
    this.isAdminUser = false;
    return;
  }

  this.userName = payload.name || '';
  this.avatarUrl = localStorage.getItem('avatar') || '';
  this.isAuthenticated = true;
  this.isAdminUser = String(payload.role || localStorage.getItem('role') || '').toLowerCase() === 'admin';
},
    handleAuthLogout() {
      this.isAuthenticated = false;
      this.userName = '';
      this.avatarUrl = '';
      this.isAdminUser = false;
    },
TorecommendHouse() {
  if (this.$route.path !== '/recommendHouse') {
    this.$router.push({path: '/recommendHouse', query: {keyword: this.input}});
  }
},
    toUserInfo(){
      if (this.$route.path !== '/userProfile') {
      this.$router.push('/userProfile');
    } else {
      console.log('Already on userProfile page');
    }
    },
    ToMainPage() {
      if (this.$route.path !== '/MainPage') {
      this.$router.push('/MainPage');
    } else {
      console.log('Already on MainPage page');
    }
    },
    ToLogin(){
      if (this.$route.path !== '/LogReg') {
      this.$router.push('/LogReg');
    } else {
      console.log('Already on LogReg page');
    }
    },
    ToRegist(){
      if (this.$route.path !== '/LogReg') {
      this.$router.push('/LogReg');
    } else {
      console.log('Already on LogReg page');
    }
    },ToHouseReviewScore(){
      if (this.$route.path !== '/HouseReviewScore') {
      this.$router.push('/HouseReviewScore');
    } else {
      console.log('Already on HouseReviewScore page');
    }
    },
    navSearch() {
      if (this.navSearchText.trim()) {
        this.$router.push({ path: '/recommendHouse', query: { keyword: this.navSearchText } });
        this.navSearchText = '';
      }
    },
    toggleMobileSidebar() {
      this.showMobileSidebar = !this.showMobileSidebar;
    },
    closeMobileSidebar() {
      this.showMobileSidebar = false;
    },
    navigateAndClose(path) {
      this.closeMobileSidebar();
      if (this.$route.path !== path) {
        this.$router.push(path);
  }
    },
    goToProfile() {
      this.closeMobileSidebar();
      if (this.isAuthenticated) {
        this.toUserInfo();
      } else {
        this.ToLogin();
      }
    },
    goToLogin() {
      this.closeMobileSidebar();
      this.ToLogin();
    },
    handleLogout() {
      this.closeMobileSidebar();
      clearStoredAuth();
      this.handleAuthLogout();
      this.$router.push('/');
    },
    expandSearch() {
      if (!this.isSearchExpanded) {
        this.isSearchExpanded = true;
        this.$nextTick(() => {
          if (this.$refs.searchInput) this.$refs.searchInput.focus();
        });
      }
    },
    collapseSearch() {
      // Small delay to allow click on Go button to fire before collapsing
      setTimeout(() => {
        this.isSearchExpanded = false;
      }, 200);
    },
    getAvatarUrl(avatar) {
      if (!avatar || avatar === '' || avatar === '/avatar/default-avatar.png') {
        return '/avatar/1.png';
      }
      const normalizedAvatar = String(avatar).trim();
      const legacyNamedAvatarMatch = normalizedAvatar.match(/Avatar\s+(\d+)\.png$/i);
      if (legacyNamedAvatarMatch) {
        return `/avatar/${legacyNamedAvatarMatch[1]}.png`;
      }
      if (normalizedAvatar.startsWith('http://') || normalizedAvatar.startsWith('https://')) {
        return normalizedAvatar;
      }
      if (normalizedAvatar.startsWith('/avatar/')) {
        return normalizedAvatar;
      }
      return '/avatar/' + normalizedAvatar.replace(/^\/+/, '');
    },
    handleAvatarError(event) {
      event.target.style.display = 'none';
    }
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

/* --- 0. ANIMATIONS --- */
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
/* --- 1. RESET & BASE --- */
.app-container {
  min-height: 100vh;
  background-color: #fcfcfc;
  font-family: 'Inter', sans-serif;
  padding-top: 72px; /* Offset for fixed navbar */
}

.main-content {
  width: 100%;
  min-height: calc(100vh - 72px);
  position: relative;
  z-index: 1;
}

/* --- 2. TRUSTPILOT NAVBAR STYLES --- */
.tp-navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 72px;
  background-color: #ffffff; /* White Background */
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  border-bottom: 1px solid rgba(0,0,0,0.05);
}

.tp-container {
  max-width: 1400px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
}

/* LEFT SECTION */
.tp-left {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 160px;
  height: 100%; /* Keep flex alignment, but child height is explicit */
}

.tp-mobile-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.tp-logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  padding: 0;
  transition: opacity 0.2s ease;
}

.tp-logo-wrapper:hover {
  opacity: 0.8;
}

.tp-logo-image {
  height: 24px;
  width: auto;
  object-fit: contain; 
  display: block;
}

/* CENTER SECTION (SEARCH) */
.tp-center {
  flex: 1;
  display: flex;
  justify-content: center;
  margin: 0 20px;
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

/* Morph container with beam effect */
.tp-search-morph {
  position: relative;
  width: 44px;
  height: 44px;
  border-radius: 22px;
  padding: 2px;
  overflow: hidden;
  cursor: pointer;
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 10px 40px -10px rgba(59,194,255,0.3);
}

/* Spinning beam border */
.tp-beam-border {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: conic-gradient(transparent, transparent, #3bc2ff, transparent);
  animation: spin 3s linear infinite;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.tp-search-morph.expanded .tp-beam-border {
  opacity: 1;
}

/* Search inner container */
.tp-search-inner {
  position: relative;
  background: white;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 0;
  z-index: 2;
  transition: padding 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.tp-search-morph.expanded .tp-search-inner {
  justify-content: flex-start;
  padding: 0 8px 0 20px;
  cursor: text;
}

/* Icon styling */
.tp-search-icon {
  flex-shrink: 0;
  color: #3bc2ff;
  font-size: 18px;
  margin-right: 0;
  transition: margin 0.4s ease;
  z-index: 3;
}

.tp-search-morph.expanded .tp-search-icon {
  margin-right: 12px;
}

/* Input animation */
.tp-search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 1rem;
  color: #334155;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.4s ease 0.1s;
  line-height: 40px;
  padding: 0;
}

.tp-search-morph.expanded .tp-search-input {
  opacity: 1;
  pointer-events: auto;
}

.tp-search-input::placeholder {
  color: #94a3b8;
}

/* Go button */
.tp-go-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: #f1f5f9;
  color: #3bc2ff;
  font-size: 1.2rem;
  cursor: pointer;
  transition: transform 0.2s, background 0.2s, color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: 8px;
  opacity: 0;
  pointer-events: none;
}

.tp-search-morph.expanded .tp-go-btn {
  opacity: 1;
  pointer-events: auto;
}

.tp-go-btn:hover {
  transform: scale(1.1);
  background: #3bc2ff;
  color: white;
}

/* Expanded state */
.tp-search-morph.expanded {
  width: 400px;
  cursor: text;
}

/* RIGHT SECTION */
.tp-right {
  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: flex-end;
}

.tp-nav-links {
  display: flex;
  align-items: center;
  gap: 8px;
}

.language-switcher {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #f8fafc;
}

.language-switcher button {
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  padding: 7px 10px;
}

.language-switcher button.active {
  background: #3bc2ff;
  color: #ffffff;
}

.mobile-language-switcher {
  width: 100%;
  justify-content: center;
}

.mobile-language-switcher button {
  flex: 1;
}

.tp-link {
  color: #1c1c1c;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  padding: 6px 0; /* Vertical padding only */
  margin: 0 12px; /* Horizontal spacing */
  position: relative;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.tp-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #3bc2ff;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease;
}

.tp-link:hover {
  opacity: 1;
  }

.tp-link:hover::after {
  transform: scaleX(1);
}

.tp-link-admin {
  color: #4338ca !important;
  font-weight: 600;
}

.tp-icon-btn {
  background: transparent;
  border: none;
  color: #1c1c1c;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
  outline: none;
  box-shadow: none;
}

.tp-icon-btn:hover {
  opacity: 0.7;
  background: transparent;
}

.tp-auth {
  display: flex;
  align-items: center;
  gap: 20px;
}

.tp-login-btn {
  background: none;
  border: none;
  color: #1c1c1c;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 20px;
  transition: background-color 0.2s ease;
}

.tp-login-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

/* User Profile Styles */
.tp-user {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.tp-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid rgba(0,0,0,0.1);
}

.tp-login-text {
  color: #1c1c1c;
  font-size: 14px;
  font-weight: 500;
}
/* --- 3. MOBILE MENU (Premium Sidebar Styles) --- */

/* Slide transition for sidebar */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: opacity 0.3s ease;
}
.slide-fade-enter-active .mobile-sidebar,
.slide-fade-leave-active .mobile-sidebar {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
}
.slide-fade-enter .mobile-sidebar,
.slide-fade-leave-to .mobile-sidebar {
  transform: translateX(-100%);
}

.mobile-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 9999;
  display: flex;
}

.mobile-sidebar {
  position: relative;
  width: 300px;
  max-width: 85vw;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  box-shadow: 8px 0 32px rgba(0,0,0,0.15);
  overflow-y: auto;
  z-index: 10000;
}

/* Sidebar Header with Gradient */
.mobile-sidebar-header {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  padding: 24px 20px;
  position: relative;
  overflow: hidden;
}

.mobile-sidebar-header::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(59,194,255,0.15) 0%, transparent 70%);
  pointer-events: none;
}

.sidebar-header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  position: relative;
  z-index: 1;
}

.sidebar-logo {
  display: flex;
  align-items: center;
}

.sidebar-logo-img {
  height: 22px;
  width: auto;
  filter: brightness(0) invert(1);
}

.sidebar-close-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255,255,255,0.1);
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
  }

.sidebar-close-btn:hover {
  background: rgba(255,255,255,0.2);
  }

/* User Profile Section */
.sidebar-user-section {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  background: rgba(255,255,255,0.08);
  border-radius: 14px;
  cursor: pointer;
  position: relative;
  z-index: 1;
  transition: background 0.2s ease;
}

.sidebar-user-section:hover {
  background: rgba(255,255,255,0.12);
}

.sidebar-avatar-wrapper {
  flex-shrink: 0;
}

.sidebar-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid rgba(59,194,255,0.5);
  object-fit: cover;
}

.sidebar-avatar-placeholder {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255,255,255,0.1);
  border: 2px solid rgba(255,255,255,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255,255,255,0.7);
}

.sidebar-user-info {
  flex: 1;
  min-width: 0;
}

.sidebar-user-name {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: white;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-user-status {
  display: block;
  font-size: 12px;
  color: rgba(255,255,255,0.6);
}

.sidebar-chevron {
  color: rgba(255,255,255,0.5);
  flex-shrink: 0;
}

/* Navigation Sections */
.mobile-nav-section {
  padding: 20px;
  border-bottom: 1px solid #f1f5f9;
}

.mobile-nav-label {
    display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #94a3b8;
  margin-bottom: 12px;
}

.mobile-nav-links {
  display: flex;
  flex-direction: column;
  gap: 4px;
  }

.mobile-nav-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 12px;
  text-decoration: none;
  color: #334155;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: pointer;
  }

.mobile-nav-item:hover,
.mobile-nav-item:active {
  background: #f1f5f9;
}

.mobile-nav-item:active {
  background: linear-gradient(135deg, #3bc2ff 0%, #0ea5e9 100%);
  color: white;
  }

.mobile-nav-item:active .nav-item-icon {
  background: rgba(255,255,255,0.2);
  color: white;
  }

.mobile-nav-item.router-link-active {
  background: #e0f2fe;
  color: #0284c7;
  }

.mobile-nav-item.router-link-active .nav-item-icon {
  background: #0ea5e9;
  color: white;
}

.nav-item-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
    flex-shrink: 0;
  color: #64748b;
  transition: all 0.2s ease;
  }

.mobile-nav-item:hover .nav-item-icon {
  background: #e2e8f0;
  color: #334155;
  }

.mobile-nav-item.highlight .nav-item-icon {
  color: white;
  }

.nav-item-text {
  flex: 1;
}

/* Sidebar Footer */
.sidebar-footer {
  margin-top: auto;
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f1f5f9;
  }

.sidebar-footer p {
  font-size: 12px;
  color: #94a3b8;
  margin: 0;
  }

/* Mobile Profile Button in Navbar */
.tp-mobile-profile {
  display: none;
  cursor: pointer;
  margin-left: auto;
  order: 99;
  }

.tp-mobile-avatar {
    width: 36px;
    height: 36px;
  border-radius: 50%;
  border: 2px solid #e2e8f0;
  object-fit: cover;
  }

.tp-mobile-avatar-placeholder {
    width: 36px;
    height: 36px;
    border-radius: 50%;
  background: #f1f5f9;
  border: 2px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}

/* --- 4. RESPONSIVE MEDIA QUERIES --- */
@media (max-width: 900px) {
  .tp-nav-links { display: none; } /* Hide mid-links on tablet */
}

@media (max-width: 768px) {
  .tp-center { display: none; } /* Hide large search on mobile */
  .tp-auth { display: none; } /* Hide desktop auth on mobile */
  .tp-mobile-toggle { display: block; } /* Show hamburger */
  .tp-mobile-profile { display: flex !important; } /* Show mobile profile button */
  .tp-icon-btn { display: none; } /* Hide notification bell on mobile */
  .tp-nav-links { display: none; } /* Hide nav links on mobile */
  .desktop-language-switcher { display: none; }
  
  .tp-container {
    padding: 0 16px;
  }
  
  .tp-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

/* True mobile phones only (max-width: 480px) */
@media (max-width: 480px) {
  .mobile-sidebar {
    width: 100%;
    max-width: 100vw;
  }

  .mobile-nav-item {
    padding: 12px 14px;
  }
  
  .nav-item-icon {
    width: 36px;
    height: 36px;
  }

  .sidebar-user-section {
    padding: 14px;
  }
  
  .sidebar-avatar,
  .sidebar-avatar-placeholder {
    width: 44px;
    height: 44px;
  }
}
</style>
